// removed by extract-text-webpack-plugin
module.exports = {"o-errorMessage":"_2mTkoNF_2WZdfcBi16LLlj"};


//////////////////
// WEBPACK FOOTER
// ./shared/components/ErrorMessage/style.scss
// module id = 879
// module chunks = 0